import { useGetCursorIndex } from './use-get-cursor-index';

export const useResizeCursor = (rotate: number) => {
    const cursorIndex = useGetCursorIndex(rotate, 4);
    const cursor = ['ns-resize', 'nesw-resize', 'ew-resize', 'nwse-resize'];
    const lrc = [cursor[2], cursor[3], cursor[0], cursor[1]];

    return {
        LC: lrc[cursorIndex],
        RC: lrc[cursorIndex],
        BC: cursor[cursorIndex],
        TC: cursor[cursorIndex],
    };
};
